<template>
  <router-link to="/" class="logo">
    <a-avatar src="/img/logo.svg" shape="square" size="large"/>
    <a-flex align="center" gap="28">
      <div>管店宝拓客</div>
    </a-flex>
  </router-link>
</template>

<script setup lang="ts">

</script>

<style scoped lang="sass">

a
  text-decoration: none

.logo
  display: flex
  align-items: center
  justify-content: space-evenly
  width: 160px
  margin-left: 8px

  > .ant-flex
    > div

      &:first-child
        font-size: 20px
        color: var(--ant-color-text-base)
        position: relative


</style>